import {
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  PopoverOrigin,
} from '@mui/material';
import { PopoverProps } from 'src/components/PopoverTrigger';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';

type PopoverRecordProps = {
  onClick: () => void;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
};

export const RecordVideoTranscriptionPopover = ({
  target,
  handleClose,
  onClick,
  anchorOrigin = { vertical: 'top', horizontal: 'left' },
  transformOrigin = { vertical: 'bottom', horizontal: 'left' },
}: PopoverProps<PopoverRecordProps>) => {
  const open = Boolean(target);
  const { translate } = useLocales();

  return (
    <Menu
      open={open}
      anchorEl={target}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
    >
      <MenuItem onClick={onClick}>
        <ListItemIcon>
          <Iconify icon="tabler:file-text-spark" />
        </ListItemIcon>
        <ListItemText
          primary={translate(
            'communicate.rtc_controls.copera_start_video_transcription',
          )}
        />
      </MenuItem>
    </Menu>
  );
};
